import { render } from "./StickerPreQuestionModal.vue?vue&type=template&id=73dbef9d&scoped=true&ts=true"
import script from "./StickerPreQuestionModal.vue?vue&type=script&lang=ts"
export * from "./StickerPreQuestionModal.vue?vue&type=script&lang=ts"

import "./StickerPreQuestionModal.vue?vue&type=style&index=0&id=73dbef9d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73dbef9d"]])

export default __exports__